function setTheme(themeName) {
  localStorage.setItem("theme", themeName);
  let classList = document.documentElement.classList;
  while (classList.length > 0) {
    classList.remove(classList.item(0));
  }
  document.documentElement.classList.add(themeName);
}

function setLanguage(language) {
  localStorage.setItem("app_language", language);
  const newLanguage = language === "si" ? "sinhala" : "english";

  document.documentElement.classList.add(newLanguage);
}

function keepTheme() {
  //setTheme('light');
  // document.documentElement.classList.add('light');
  if (localStorage.getItem("theme")) {
    if (localStorage.getItem("theme") === "dark") {
      setTheme("dark");
    } else if (localStorage.getItem("theme") === "light") {
      setTheme("light");
    }
  } else {
    setTheme("light");
  }
}

module.exports = {
  setTheme,
  keepTheme,
  setLanguage,
};
